import React from 'react'
import { Link } from 'react-router-dom'
import OrgsSmallCommentInput from './OrgsSmallCommentInput'
import OrgsSmallComment from './OrgsSmallComment';
import { connect } from 'react-redux'
import { getLabel } from "../../../language";
import { APP_CONFIG } from "../../../appconfig"
const defaultAvatar = APP_CONFIG.defaultAvatar;

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.user
  }
}

export class OrgsSmallCommentContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showComments: false
    };
    this.addCommentClick = this.addCommentClick.bind(this);
  }

  addCommentClick() {
    this.setState({
      showComments: true
    })
  }

  render() {
    const comment = this.props.comments && this.props.comments[this.props.comments.length - 1];
    return (
      <div className="row small-comments">
        <div className="col-md-12">
          {this.props.isAvailableForReply && <p className="text-right">{getLabel(206)}</p>}
            <div>
              {this.props.comments ?
                this.props.comments.reverse().map((comment, index) => {
                  return <OrgsSmallComment
                    key={index}
                    {...comment}
                      abuseData={comment.abuse}
                    avatar={defaultAvatar}
                    goal={this.props.goal}
                    isAvailableForReply={this.props.isAvailableForReply}
                  />
                })
                : null}
            </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(OrgsSmallCommentContainer);
